
<div class="dash-section m-3 p-3">
  <div class="row">
    <div class="col font-weight-bold text-black-50">
      Home
    </div>
    <div class="col">
      <button
        class="btn float-right btn-md text-white px-3 filter-orange-bg"
        id="toggleMessage"
        (click)="toggleDateFilter()"
      >
        {{ toggleFilter ? 'Show filter' : 'Hide filter'
        }}<i class="fas fa-chevron-up"></i>
      </button>
    </div>
  </div>
  <hr />
  <div *ngIf="!toggleFilter">
    <div class="row py-1">
      <div class="col-sm-4 font-weight-bold">
        Start date
      </div>
      <div class="col-sm-4 font-weight-bold">
        End date
      </div>
    </div>
    <div class="row pt-1 bg-light border-bottom">
      <div class="col">
        <input
          [owlDateTime]="dt1"
          [owlDateTimeTrigger]="dt1"
          placeholder="Select Start Date"
          class="form-control"
          [(ngModel)]="startDateVal"
        />
        <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
      </div>
      <div class="col">
        <input
          [owlDateTime]="dt2"
          [owlDateTimeTrigger]="dt2"
          placeholder="Select End Date"
          class="form-control"
          [(ngModel)]="endDateVal"
        />
        <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
      </div>
      <div class="col">
        <button
          (click)="datePicker()"
          class="btn btn-md px-5 filter-teal-bg text-white float-right"
          [disabled]="invalidDateTime"
        >
          Apply
        </button>
      </div>
    </div>
    <div
      *ngIf="invalidDateTime"
      class="row alert alert-danger alert-dismissible filter-board-size py-2 mx-1"
    >
      <a href="#" class="close" data-dismiss="alert" aria-label="close"
        >&times;</a
      >
      <div class="col">
        Start date should not be greater than End date.
      </div>
    </div>
  </div>
</div>
<div *ngIf="loaded; else elseBlock">
  <div class="row m-3 text-black-50">
    <div class="col dash-section mr-3 p-5">
      <div class="row border-bottom py-3">
        <div class="col-lg-6">
          <a routerLink="/farmers">Farmers</a>
        </div>
        <div class="col-lg-3">
          <span class="btn btn-primary btn-block" *ngIf="villageAgents">
            {{ topDistricts.farmerCount }}
          </span>
        </div>
        <div class="col-lg-3">
          <i
            [className]="
              topDistricts.percentage >= 0
                ? 'fas fa-chevron-up'
                : 'fas fa-chevron-down'
            "
          ></i>
          <span
            [className]="
              topDistricts.percentage >= 0 ? 'text-green' : 'text-red'
            "
          >
            {{ topDistricts.percentage | number: '1.0-1' }}%</span
          >
        </div>
      </div>

      <div class="row border-bottom py-3">
        <div class="col-lg-6">
          <a routerLink="/village-agents">Village agents</a>
        </div>
        <div class="col-lg-3">
          <span class="btn btn-secondary btn-block" *ngIf="villageAgents">{{
            villageAgents.count
          }}</span>
        </div>
        <div class="col-lg-3">
          <i
            [className]="
              villageAgents.percentage >= 0
                ? 'fas fa-chevron-up'
                : 'fas fa-chevron-down'
            "
          ></i>
          <span
            [className]="
              villageAgents.percentage >= 0 ? 'text-green' : 'text-red'
            "
          >
            {{ villageAgents.percentage | number: '1.0-1' }}%</span
          >
        </div>
      </div>

      <div class="row border-bottom py-3">
        <div class="col-lg-6">
          <a routerLink="/financial-institutions">Financial institutions</a>
        </div>
        <div class="col-lg-3">
          <span class="btn btn-success btn-block">0</span>
        </div>
        <div class="col-lg-3">
          <i class="fas fa-chevron-up"></i> <span class="text-green"> 0%</span>
        </div>
      </div>

      <div class="row border-bottom py-3">
        <div class="col-lg-6">
          <a routerLink="/suppliers">Input suppliers</a>
        </div>
        <div class="col-lg-3">
          <span
            class="btn filter-orange-bg text-white btn-block"
            *ngIf="inputSuppliers"
            >{{ inputSuppliers.count }}</span
          >
        </div>
        <div class="col-lg-3">
          <i
            [className]="
              inputSuppliers.percentage >= 0
                ? 'fas fa-chevron-up'
                : 'fas fa-chevron-down'
            "
          ></i>
          <span
            [className]="
              inputSuppliers.percentage >= 0 ? 'text-green' : 'text-red'
            "
          >
            {{ inputSuppliers.percentage | number: '1.0-1' }}%</span
          >
        </div>
      </div>

      <div class="row border-bottom py-3">
        <div class="col-lg-6">
          <a routerLink="/offtakers">Offtakers</a>
        </div>
        <div class="col-lg-3">
          <span class="btn btn-info btn-block" *ngIf="offtakers">{{
            offtakers.count
          }}</span>
        </div>
        <div class="col-lg-3">
          <i
            [className]="
              offtakers.percentage >= 0
                ? 'fas fa-chevron-up'
                : 'fas fa-chevron-down'
            "
          ></i>
          <span
            [className]="offtakers.percentage >= 0 ? 'text-green' : 'text-red'"
          >
            {{ offtakers.percentage | number: '1.0-1' }}%</span
          >
        </div>
      </div>

      <div class="row border-bottom py-3">
        <div class="col-lg-6">
          <a routerLink="/devt-partners">Devt partners</a>
        </div>
        <div class="col-lg-3">
          <span class="btn btn-danger btn-block" *ngIf="devtPartners">
            {{ devtPartners.count }}
          </span>
        </div>
        <div class="col-lg-3">
          <i
            [className]="
              devtPartners.percentage >= 0
                ? 'fas fa-chevron-up'
                : 'fas fa-chevron-down'
            "
          ></i>
          <span
            [className]="
              devtPartners.percentage >= 0 ? 'text-green' : 'text-red'
            "
          >
            {{ devtPartners.percentage }}%</span
          >
        </div>
        <div class="col-lg-3" *ngIf="devtPartners.percentage < 0">
          <i class="fas fa-chevron-down"></i>
          <span class="text-red">
            {{ devtPartners.percentage | number: '1.0-1' }}%</span
          >
        </div>
      </div>
    </div>

    <div class="col dash-section mr-3 p-5">
      <h2 class="text-teal">Farmer & distribution</h2>
      <app-farmer-distribution
        [districtData]="topDistricts.allDistricts"
        [vaDistrictData]="villageAgentsDistricts"
      ></app-farmer-distribution>
    </div>

    <div class="col dash-section p-5">
      <h2 class="d-inline-block mb-4 text-teal">Top districts</h2>
      <span class="btn btn-light float-right">{{
        topDistricts.farmerCount !== 0 ? 'See report' : ''
      }}</span>
      <div class="my-3">
        <div class="mb-2">
          <span class="h4">{{
            topDistricts.farmerCount === 0 ? 'No district available.' : ''
          }}</span>
        </div>
      </div>
      <div *ngIf="topDistricts">
        <div
          class="my-3"
          *ngFor="
            let district of topDistricts.topDistricts | keyvalue: valueDescOrder
          "
        >
          <div class="mb-2">
            <span class="h4 text-bold">{{ district.value.farmer_count }}</span>
            <small> farmers</small>
          </div>
          <div>
            <span>From {{ district.key.farmer_name }}</span>
            <span class="float-right"
              >{{
                (district.value / topDistricts.farmerCount) * 100
                  | number: '1.0-1'
              }}
              %</span
            >
          </div>
          <div>
            <progress
              max="100"
              value="{{ (district.value / topDistricts.farmerCount) * 100 }}"
            ></progress>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row m-3">
    <div class="col-8 mr-3 p-5 dash-section text-black-50">
      <div class="row align-items-baseline border-bottom py-4">
        <div class="col-10" *ngIf="totalPayment">
          <h1 class="text-orange number-mid text-bold">
            {{ totalPayment.totalPayment.toFixed() | number }}
          </h1>
          <span class="text-muted">Total payments</span>
        </div>
        <div class="col">
          <div class="stats-bottom">
            <div>
              <i
                [className]="
                  totalPayment.percentagePayment >= 0
                    ? 'fas fa-chevron-up'
                    : 'fas fa-chevron-down'
                "
              ></i>
              <span
                [className]="
                  totalPayment.percentagePayment >= 0
                    ? 'text-green'
                    : 'text-red'
                "
              >
                {{ totalPayment.percentagePayment | number: '1.0-1' }}%</span
              >
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="activitySummary">
        <div
          class="row border-bottom py-4 row-striped"
          *ngFor="let activity of activitySummary.activities | keyvalue"
        >
          <div class="col-5">{{ activity.key }}</div>
          <div class="col-4 text-bold">{{ activity.value }}</div>
          <div class="col-3">
            <i
              [className]="
                activitiesPercentage[activity.key] >= 0
                  ? 'fas fa-chevron-up'
                  : 'fas fa-chevron-down'
              "
            ></i>
            <span
              [className]="
                activitiesPercentage[activity.key] >= 0
                  ? 'text-green'
                  : 'text-red'
              "
            >
              {{ activitiesPercentage[activity.key] | number: '1.0-1' }}%</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="col p-5 dash-section">
      <div class="row">
        <div class="col mb-5 pb-5 border-bottom">
          <h2 class="text-teal">Total Acreage</h2>
          <div class="row">
            <div class="col-6">
              <img src="assets/images/acreage_single.png" />
            </div>
            <div
              *ngIf="totalAcreage"
              class="col-6"
              style="display: flex; align-items: center;"
            >
              <div class="acreage-count">
                <img src="assets/images/acreage_arrow.png" /><span
                  >{{ totalAcreage.totalAcreage.toFixed() }} Acres</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-100"></div>
        <div class="col mt-5">
          <h2 class="text-teal">Total Districts covered</h2>
          {{ topDistricts.districtCount }} districts
        </div>
      </div>
    </div>
  </div>

  <div class="row m-3">
    <div class="col-8 mr-3 p-5 dash-section text-black-50">
      <div class="row align-items-baseline border-bottom py-4">
        <div class="col">
          <h2 class="text-teal">Farmers vs Enterprise</h2>
        </div>
        <div class="col">
          <div class="stats-bottom float-right">
            <div class="btn btn-light">
              {{ topProduce.farmProduceCount !== 0 ? 'See report' : '' }}
            </div>
          </div>
        </div>
      </div>
      <div class="my-3">
        <div class="mb-2">
          <span class="h4">{{
            topProduce.farmProduceCount === 0 ? 'No produce available.' : ''
          }}</span>
        </div>
      </div>
      <div *ngIf="topProduce">
        <div
          class="row border-bottom py-4 row-striped"
          *ngFor="
            let produce of topProduce.topFarmProduce
              | keyvalue
              | orderBy: 'value':true
          "
        >
          <div class="col-5">{{ produce.key }}</div>
          <div class="col-4 text-bold">
            {{ produce.value.toFixed() | number }}
          </div>
          <div class="col-3">Farmers</div>
        </div>
      </div>
    </div>

    <div class="col p-5 dash-section">
      <div class="row text-black-50">
        <div class="col mb-5">
          <h2 class="mb-5 text-teal">EzyAgric Downloads</h2>
          <span class="h3">EzyAgric Mobile app</span>
          <span class="float-right">40%</span>
          <div>
            <progress max="100" value="40"></progress>
          </div>
          <span>29,000/39,000 active users</span>
        </div>
        <div class="w-100"></div>
        <div class="col my-5">
          <span class="h3">EzyAgric Web</span>
          <span class="float-right"
            >{{
              (activeUsers.activeUsersCount / activeUsers.allUsersCount) * 100
                | number: '1.0-1'
            }}%</span
          >
          <div>
            <progress
              max="100"
              value="{{
                (activeUsers.activeUsersCount / activeUsers.allUsersCount) * 100
              }}"
            ></progress>
          </div>
          <span
            >{{ activeUsers.activeUsersCount.toFixed() | number }}/{{
              activeUsers.allUsersCount.toFixed() | number
            }}
            active users</span
          >
        </div>
      </div>
    </div>
  </div>

  <div class="row m-3 dash-section">
    <div class="col p-5">
      <h1 class="mb-5 text-teal">
        Farmers and Agents-Farmers orders statistics
      </h1>
      <div id="line-chart-container" class="col">
        <ngx-charts-area-chart-stacked
          [results]="farmersAgentsOrderStatistics"
          [scheme]="colorScheme"
          [gradient]="gradient"
          [xAxis]="showXAxis"
          [yAxis]="showYAxis"
          [xAxisLabel]="xAxisLabel"
          [yAxisLabel]="yAxisLabel"
          [showXAxisLabel]="showXAxisLabel"
          [showYAxisLabel]="showYAxisLabel"
          [legend]="showLegend"
          [legendTitle]="legendTitle"
          [legendPosition]="legendPosition"
        >
        </ngx-charts-area-chart-stacked>
      </div>
    </div>
  </div>

  <div class="container">
    <router-outlet></router-outlet>
  </div>
</div>
<ng-template #elseBlock>
  <div class="spinner d-flex">
    <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
  </div>
</ng-template>
